<div style="position: relative; /* or absolute */
top: 0%;
left: 1%;
width: 97%;">
<h2>{{'CONTROL-TEAM.TITLE' | translate}}</h2>
<ntr-add-button [openView]="'control-team/add'"></ntr-add-button>

<ntr-datatable [data]="data" [metaInfo]="metaInfo" [entityTitle]="'controlTeam'" [modelView]="'control-team'"
               [disableHeader]="false"
               (onQuery)="onGridQuery($event)"
               [columns]="columns"
               [headers]="['','Name','Created By','Create Date', 'Description','Last modified by']"
               (onDeleteQuery)="deleteControlTeam($event)">
</ntr-datatable>
</div>